/**
 * @generated SignedSource<<93989c5d369f8f82f680939606a64898>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifierTypeId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifierUseCodeId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  },
  (v6/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BillingGroupMutationGroup",
    "kind": "LinkedField",
    "name": "billingGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "billingGroupIdentifierId",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "effectiveFrom",
                "variableName": "effectiveFrom"
              },
              {
                "kind": "Variable",
                "name": "effectiveTo",
                "variableName": "effectiveTo"
              },
              {
                "kind": "Variable",
                "name": "identifierTypeId",
                "variableName": "identifierTypeId"
              },
              {
                "kind": "Variable",
                "name": "identifierUseCodeId",
                "variableName": "identifierUseCodeId"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "value"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "BillingGroupIdentifierModifyPayload",
        "kind": "LinkedField",
        "name": "modifyIdentifier",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingGroupIdentifier",
            "kind": "LinkedField",
            "name": "billingGroupIdentifier",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingGroup",
                "kind": "LinkedField",
                "name": "billingGroup",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveTo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierUseCode",
                "kind": "LinkedField",
                "name": "identifierUseCode",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IdentifierType",
                "kind": "LinkedField",
                "name": "identifierType",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBillingGroupIdentifierModalMutation",
    "selections": (v8/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditBillingGroupIdentifierModalMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "0edae64f2a0281b35fb632abba77b6d7",
    "id": null,
    "metadata": {},
    "name": "EditBillingGroupIdentifierModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditBillingGroupIdentifierModalMutation(\n  $id: ID!\n  $identifierTypeId: ID!\n  $identifierUseCodeId: ID!\n  $value: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  billingGroup {\n    modifyIdentifier(input: {billingGroupIdentifierId: $id, value: $value, identifierTypeId: $identifierTypeId, identifierUseCodeId: $identifierUseCodeId, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      billingGroupIdentifier {\n        id\n        billingGroup {\n          id\n        }\n        effectiveFrom\n        effectiveTo\n        value\n        identifierUseCode {\n          display\n          id\n        }\n        identifierType {\n          display\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f199e33eced6484bff7e0912a6fdf371";

export default node;
